<template>
  <div class="products">
    <div class="toolbar" v-if="!isLoading">
      <h1>Có {{ totalProducts }} sản phẩm</h1>
      <div class="actions" ref="layouts">
        <Select
          :configs="priceFilterDropdown"
          @selected="sortByPrice($event)"
        />

        <Select :configs="dateFilterDropdown" @selected="sortByDate($event)" />

        <span>Sắp xếp</span>
        <img
          @click="changeLayout('row-cols-2', 0)"
          src="@/assets/icons/row-vertical.svg"
          alt=""
        />
        <img
          @click="changeLayout('row-cols-3', 1)"
          src="@/assets/icons/element-4.png"
          alt=""
        />
        <img
          @click="changeLayout('row-cols-4', 2)"
          src="@/assets/icons/element-3.png"
          alt=""
        />
      </div>
    </div>
    <Loading v-if="isLoading" />
    <ProductContainer
      v-else
      :products="products"
      :configs="configs"
      @loadMore="loadMore()"
    />
  </div>
</template>

<script>
import ProductContainer from "./components/ProductContainer.vue";
import Loading from "./components/Loading.vue";
import Select from "./components/Dropdown.vue";

import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions } = createNamespacedHelpers("publicStoreModule");
export default {
  name: "Products",
  components: {
    ProductContainer,
    Loading,
    Select,
  },
  data() {
    return {
      configs: {
        layout: "row-cols-4",
        class: "row g-3",
      },
      priceFilterDropdown: {
        label: "Giá",
        options: [
          { key: 1, value: "Tăng dần" },
          { key: 2, value: "Giảm dần" },
        ],
      },
      dateFilterDropdown: {
        label: "Ngày cập nhật",
        options: [
          { key: 1, value: "Mới nhất" },
          { key: 2, value: "Cũ nhất" },
        ],
      },
      filterOptions: {},
    };
  },
  created() {
    const params = { page: this.page };
    this.getProducts(params);
  },
  methods: {
    ...mapActions(["getProducts", "mergeProducts"]),
    loadMore() {
      this.mergeProducts();
      console.log("Load more");
    },
    changeLayout(layout, index) {
      this.configs.layout = layout;
      this.$refs.layouts.querySelectorAll("img").forEach((img, i) => {
        img.classList.remove("active");
        if (index == i) img.classList.add("active");
      });
    },
    sortByPrice(option) {
      this.filterOptions.price = option;
      alert(option);
    },
    sortByDate(option) {
      this.filterOptions.createdDate = option;
      alert(option);
    },
  },
  computed: {
    totalProducts() {
      return this.products.length;
    },
    ...mapState(["products", "isLoading"]),
  },
};
</script>
<style scoped lang="scss">
.products {
  padding-top: 50px;
  .toolbar {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 50px;
    h1 {
      font-size: 24px;
    }
    .actions {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        margin-right: 15px;
        font-size: 14px;
        font-weight: 500;
        opacity: 0.6;
      }
      img {
        cursor: pointer;
        height: 25px;
        margin-right: 10px;
        opacity: 0.6;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          opacity: 1;
        }
      }
    }
  }
}
@media screen and (max-width: 1660px) and (min-width: 1279px) {
  .toolbar {
    padding: 0 80px;
  }
}
@media screen and (max-width: 1279px) and (min-width: 769px) {
  .toolbar {
    padding: 0 60px;
    .actions {
      display: none !important;
    }
  }
}
@media screen and (max-width: 768px) and (min-width: 481px) {
  .toolbar {
    padding: 0 40px;
    .actions {
      display: none !important;
    }
  }
}
@media screen and (max-width: 480px) and (min-width: 0) {
  .toolbar {
    flex-direction: column;
    .actions {
      display: none !important;
    }
  }
}
</style>
